import AttendanceView from 'features/attendance/view/AttendanceView';
import StaffAttendanceView from 'features/attendance/view/StaffAttendanceView';
import UsersView from 'features/users/view/UsersView';
import BookView from 'features/book/view/BookView';
import ResultView from 'features/result/view/ResultView';
import RoutineView from 'features/routine/view/RoutineView';
import AnnouncementView from 'features/announcement/view/AnnouncementView';
import SupportView from 'features/support/view/SupportView';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Sidebar from '../component/Sidebar/Sidebar';
import { HomeViewWrapper } from './home.style';
import ExamRoutineView from 'features/examRoutine/view/ExamRoutineView';
import DashboardView from 'features/dashboard/view/DashboardView';
import SubjectView from 'features/subject/view/SubjectView';
import ClassView from 'features/class/view/ClassView';

export default function HomeView() {
  return (
    <HomeViewWrapper>
      <div className="main-container">
        <Sidebar />
        <div className="content-area">
          <Switch>
            <Route path="/" exact component={DashboardView}></Route>
            <Route path="/dashboard" exact component={DashboardView}></Route>
            <Route path="/users" exact component={UsersView}></Route>
            <Route path="/attendance" exact component={AttendanceView}></Route>
            <Route path="/attendance/staff" exact component={StaffAttendanceView}></Route>
            <Route path="/result" exact component={ResultView}></Route>
            <Route path="/announcement" exact component={AnnouncementView}></Route>
            <Route path="/attendance/support" exact component={SupportView}></Route>
            <Route path="/book" exact component={BookView}></Route>
            <Route path="/routine" exact component={RoutineView}></Route>
            <Route path="/examRoutine" exact component={ExamRoutineView}></Route>
            <Route path="/subject" exact component={SubjectView}></Route>
            <Route path="/class" exact component={ClassView}></Route>
          </Switch>
        </div>
      </div>
    </HomeViewWrapper>
  );
}
